module.exports = __webpack_public_path__ + "static/media/hoppers-moth.f34327d0.jpg";